export const decodeBase64Email = (encoded?: string | null): string | null => {
  if (!encoded) return null;

  try {
    const decoded = atob(encoded);
    // very light validation to avoid garbage
    return decoded.includes('@') ? decoded : null;
  } catch {
    return null;
  }
};
